import util from '../util';

// 解析html字符串中script标签并添加到body中
function runScript(list) {
    var psScripts = Promise.resolve();
    list.forEach(m => {
        var s = m.match(/^\<script([^>]*)\>([\s\S]*)\<\\\/script\>$/);
        if (s) {
            // console.log(s);
            // <s cript>内部有代码的情况
            if (s[2] && /\w/.test(s[2])) {
                psScripts = psScripts.then(() => {
                    new Function('window', s[2])(window);
                });
            }
            // <s cript>标签有属性的情况(通常是外链)
            else if (s[1]) {
                var attrObj = {};
                s[1].split(' ').forEach(item => {
                    if (item) {
                        var strs = item.match(/([\w]*)=(.*)/); // 保留url后面的参数
                        if (strs) {
                            // sync deffer 这类没有
                            var key = strs[1] || '';
                            var value = (strs[2] || '')
                                .replace(/^['"]/, '')
                                .replace(/['"]$/, '');
                            if (key) {
                                attrObj[key] = value;
                            }
                        }
                    }
                });
                if (attrObj.src) {
                    psScripts = psScripts.then(() => {
                        return util.addScript(
                            attrObj.src,
                            true,
                            document,
                            attrObj
                        );
                    });
                }
            }
        }
    });
}

// 生成html, 并插入到el
export function decodeHtml(el, binding, vnode) {
    if (vnode.context.htmlData !== binding.value) {
        vnode.context.htmlData = binding.value;
        const reg = /\<script[^>]*\>[\s\S]*?\<\\\/script\>/g;
        // 解析<script><\/script>, 手动转换成脚本加载
        var value = binding.value || '';
        var mlist = value.match(reg);
        if (mlist) {
            el.innerHTML = value.replace(reg, '');
            runScript(mlist);
        } else {
            el.innerHTML = binding.value;
        }
    }
}
